import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  IApiResponse,
  IBlockedCustomerDto,
  IBlockedUserDto,
  ICustomerDto,
  IFilterPaginationDto,
  IUserDto,
} from '../models';

@Injectable()
export class UserService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getUserList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IUserDto[]> {
    return this.post(`admin/user/list/${id}`, model);
  }

  public saveUser(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/user/save`, model);
  }

  public deleteUser(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/user/${id}`);
  }

  public getBlockedUserList(
    model: IFilterPaginationDto
  ): Observable<IBlockedUserDto[]> {
    return this.post(`admin/user/blocked/list`, model);
  }

  public unblockUser(
    model: IBlockedUserDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/user/unblock`, model);
  }

  public changePassword(
    model: KeyValue<number, string>
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/user`, model);
  }

  public getCustomerList(
    id: number = 0,
    model: IFilterPaginationDto
  ): Observable<ICustomerDto[]> {
    return this.post(`admin/customer/list/${id}`, model);
  }

  public getGuestCustomerList(
    id: number = 0,
    model: IFilterPaginationDto
  ): Observable<ICustomerDto[]> {
    return this.post(`admin/customer/guest/list/${id}`, model);
  }

  public getBlockedCustomerList(
    id: number = 0,
    model: IFilterPaginationDto
  ): Observable<IBlockedCustomerDto[]> {
    return this.post(`admin/customer/blocked/list/${id}`, model);
  }

  public blockCustomer(
    model: IBlockedCustomerDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/customer/block/save`, model);
  }

  public changeBlockedCustomerStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/customer/block/${id}`, null);
  }

  public changeCustomerStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/customer/${id}`, null);
  }

  public deleteCustomer(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/customer/${id}`);
  }
}
